import { useEffect, useState } from 'react'

import { Metaverse } from 'types/Metaverse'

import { useAppErrorContext } from 'contexts/AppErrorContext'

import { metaversesApi } from 'api/metaverses-api'

export const useCreateMetaOpts = (
  defaultOption: { value: string; label: string } = { value: '', label: 'Select metaverse...' },
  removeFirstOnload: boolean = false
) => {
  const [filterOpts, setFilterOpts] = useState<{ value: string; label: string }[]>([
    { value: '', label: 'All Metaverses' },
  ])
  const [metaOpts, setMetaOpts] = useState<{ value: string; label: string }[]>([defaultOption])

  const { setAppError } = useAppErrorContext()

  useEffect(() => {
    metaversesApi
      .getAll()
      .then((res) => {
        const metaverses: Metaverse[] = res.data.data
        setMetaOpts((prev) =>
          removeFirstOnload
            ? metaverses.map((meta) => ({ value: meta.name, label: meta.name }))
            : [
                ...prev,
                ...metaverses.map((meta) => ({
                  value: meta.name,
                  label: meta.name,
                })),
              ]
        )
        setFilterOpts((prev) => [
          ...prev,
          ...metaverses.map((meta) => ({
            value: `${meta.name}-String-eq`,
            label: meta.name,
          })),
        ])
      })
      .catch((e) => setAppError(e))
  }, [])

  return { metaverseOptions: metaOpts, filterMetaverseOptions: filterOpts }
}
